import request from './request.js'

export function getGovmoLoginURL(lang, appenv, redirectPath) {
  return request({
    url: `/govmo-login-url`,
    method: 'post',
    data: { lang, appenv, redirectPath }
  }, {
    withCredentials: false,
  })
}

export function sendOtp(lang) {
  return request({
    url: `/send-otp`,
    method: 'post',
    data: { lang }
  })
}

export function verifyOtp(otp) {
  return request({
    url: `/verify-otp`,
    method: 'post',
    data: { otp }
  })
}
